export default defineNuxtPlugin(() => {
    return {
        provide: {
            ttq: (() => {
                if (process.client) {
                    (function (w, d, t) {
                        w.TiktokAnalyticsObject = t;
                        const ttq = (w[t] = w[t] || []);
                        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
                        ttq.setAndDefer = function (t, e) {
                            t[e] = function () {
                                t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                            };
                        };
                        for (let i = 0; i < ttq.methods.length; i++) {
                            ttq.setAndDefer(ttq, ttq.methods[i]);
                        }
                        ttq.instance = function (t) {
                            const e = ttq._i[t] || [];
                            for (let n = 0; n < ttq.methods.length; n++) {
                                ttq.setAndDefer(e, ttq.methods[n]);
                            }
                            return e;
                        };
                        ttq.load = function (e, n) {
                            const r = "https://analytics.tiktok.com/i18n/pixel/events.js";
                            const o = n && n.partner;
                            ttq._i = ttq._i || {};
                            ttq._i[e] = [];
                            ttq._i[e]._u = r;
                            ttq._t = ttq._t || {};
                            ttq._t[e] = +new Date();
                            ttq._o = ttq._o || {};
                            ttq._o[e] = n || {};
                            const s = document.createElement("script");
                            s.type = "text/javascript";
                            s.async = true;
                            s.src = `${r}?sdkid=${e}&lib=${t}`;
                            const f = document.getElementsByTagName("script")[0];
                            f.parentNode?.insertBefore(s, f);
                        };

                        ttq.load("D06HV5JC77U9TS4J3UUG");
                        ttq.page();
                    })(window, document, "ttq");

                    return window.ttq;
                }
                return null;
            })(),
        },
    };
});
